import { FC } from 'react';
import { Table } from '../Table/Table';
import { Badge, IProps } from '../Badge/Badge';
import useTheme from '../../utils/useTheme';
import styled from 'styled-components';

export const HistoryBadge: FC<IProps> = props => {
  const theme = useTheme();
  return (
    <Badge variation="normal" color={theme.designToken.primary300} rounded={4} {...props}>
      {props.children}
    </Badge>
  );
};

export const StyledHistoryTable = styled(Table)`
  & .rt-thead .rt-tr button.rt-th {
    font-weight: 600;
    font-size: 16px;
  }

  & .rt-thead .rt-tr button.rt-th svg[role='img'] {
    display: none;
  }

  & .rt-thead .rt-tr button.th-center div {
    width: 100%;
    text-align: center;
    margin-right: 0;
  }
`;

StyledHistoryTable.defaultProps = {
  ...StyledHistoryTable.defaultProps,
  sortable: false,
};
